import React from "react";
import Image from "next/image";
import { ListItem } from "@/types";

type ListItemsGridProps = {
  listItems: ListItem[];
};

const ListItemsGrid: React.FC<ListItemsGridProps> = ({ listItems }) => {
  return (
    <div className="mt-12 grid grid-cols-2 gap-12">
      {listItems.map((item) => (
        <div key={item.id} className="flex items-start space-x-4">
          <Image
            width={10}
            height={10}
            src={item.icon}
            alt="Check icon"
            className="h-8 w-4"
          />
          <div>
            <p className="text-sm text-gray-800">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListItemsGrid;
